import { create } from "zustand";

export const APP_STATUS_NONE = Symbol('NONE');
export const APP_STATUS_BLOCKED = Symbol('BLOCKED');
export const APP_STATUS_IDLE = Symbol('IDLE');
export const APP_STATUS_ACTIVE = Symbol('ACTIVE');
export const APP_STATUS_READY = Symbol('READY');

export const useAppStore = create((set, get) => ({
  status: APP_STATUS_NONE,
  _isReady: false,
  setError: () => set({ status: APP_STATUS_BLOCKED }),
  setActive: () => set({ status: APP_STATUS_ACTIVE }),
  setIdle: () => set({ status: APP_STATUS_IDLE, _isReady: false }),
  setReady: () => set({ _isReady: true, status: APP_STATUS_READY }),
  setBlocked: () => set({ status: APP_STATUS_BLOCKED }),
  getStatus: () => get().status,
  get blocked() {
    return get().status === APP_STATUS_BLOCKED
  },
  isBlocked() {
    return get().status === APP_STATUS_BLOCKED
  },
  isReady() {
    return get()._isReady;
  },
  get active() {
    return get().status === APP_STATUS_ACTIVE
  },
  get cssStatus() {
    switch(get().status) {
      default:
      case APP_STATUS_IDLE:
        return 'idle';
      case APP_STATUS_BLOCKED:
        return 'ready idle';
      case APP_STATUS_ACTIVE:
        return 'ready';
      case APP_STATUS_READY:
        return 'ready';
    }
  },
}));

useAppStore.APP_STATUS_NONE    = APP_STATUS_NONE;
useAppStore.APP_STATUS_BLOCKED = APP_STATUS_BLOCKED;
useAppStore.APP_STATUS_IDLE    = APP_STATUS_IDLE;
useAppStore.APP_STATUS_ACTIVE  = APP_STATUS_ACTIVE;
useAppStore.APP_STATUS_READY   = APP_STATUS_READY;
useAppStore.disabledStates = [
  APP_STATUS_BLOCKED,
  APP_STATUS_IDLE,
  APP_STATUS_NONE,
];